import React from "react";
import "./IndustriesWeWorkStyle.scss";
import { industriesWeWorkTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const IndustriesWeWorkSection = () => {
  return (
    <section className="industries-we-work-section">
      <div className="industries-we-work-wrap">
        <SectionHeading>{industriesWeWorkTextContent.headingText}</SectionHeading>

        <div className="industries-we-work-box">
          <div className="cards-grid">
            {industriesWeWorkTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-header">
                  <div className="icon-box">
                    <img src={section.iconSrc} alt="Image" />
                  </div>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>

                <div className="card-body">
                  <p className="para-text">{section.paraText}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesWeWorkSection;
